'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Carousel = require('../../carousel/main/jsx/Carousel');

var _Carousel2 = _interopRequireDefault(_Carousel);

var _clone = require('../../../../utilities/clone');

var _clone2 = _interopRequireDefault(_clone);

var _SocialProofItem = require('./SocialProofItem');

var _SocialProofItem2 = _interopRequireDefault(_SocialProofItem);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'social-proof-carousel';

var SocialProof = function (_React$Component) {
  _inherits(SocialProof, _React$Component);

  function SocialProof(props) {
    _classCallCheck(this, SocialProof);

    var _this = _possibleConstructorReturn(this, (SocialProof.__proto__ || Object.getPrototypeOf(SocialProof)).call(this, props));

    _this.renderHeadline = function (headline) {
      if (headline && headline.text) {
        return _react2.default.createElement(
          'div',
          { className: 'row text-xs-center' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(
              _heading2.default,
              { level: 2, className: 'panels__headline' },
              headline.text
            )
          )
        );
      }

      return null;
    };

    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.state = {
      showImages: false
    };
    return _this;
  }

  _createClass(SocialProof, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var domRect = this.sectionElement && this.sectionElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      window.removeEventListener('scroll', this.handleScroll);
      this.enableImages();
    }
  }, {
    key: 'renderSlides',
    value: function renderSlides(slides) {
      var _this2 = this;

      if (slides) {
        return slides.map(function (slide, idx) {
          var itemProperties = {
            content: slide.content,
            config: (0, _clone2.default)(slide.config)
          };
          itemProperties.config.theme = _this2.props.config.theme;
          return _react2.default.createElement(_SocialProofItem2.default, _extends({
            className: ORGANISM_NAME + '__carousel__social-proof'
          }, itemProperties, {
            key: ORGANISM_NAME + '-' + idx,
            showImages: _this2.state.showImages
          }));
        });
      }
      return null;
    }
  }, {
    key: 'renderCarousel',
    value: function renderCarousel(slides) {
      var _props = this.props,
          config = _props.config,
          content = _props.content;
      var fpti = config.fpti;
      var carousel = content.carousel;

      var options = {
        startSlide: 0,
        speed: 400,
        className: ORGANISM_NAME,
        continuous: false
      };
      return _react2.default.createElement(
        'div',
        {
          key: slides.length,
          className: ORGANISM_NAME + '__wrapper'
        },
        _react2.default.createElement(
          _Carousel2.default,
          {
            className: (0, _classnames2.default)(ORGANISM_NAME + '__carousel', _defineProperty({}, ORGANISM_NAME + '--use-image', slides.some(function (slide) {
              return slide.config.type === 'image';
            }))),
            trackId: fpti || 'SocPrf-Carousel',
            options: options,
            content: carousel
          },
          this.renderSlides(slides, this.props)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          config = _props2.config,
          content = _props2.content,
          className = _props2.className;
      var id = config.id,
          theme = config.theme;
      var slides = content.slides,
          headline = content.headline;

      // Only return the single organism if only one slide is provided

      if (slides && slides.length === 1) {
        var itemProperties = {
          content: slides[0].content,
          config: (0, _clone2.default)(slides[0].config)
        };
        itemProperties.config.theme = theme;
        return _react2.default.createElement(_SocialProofItem2.default, itemProperties);
      }

      var socialProofClasses = (0, _classnames2.default)(ORGANISM_NAME, className, theme);
      return _react2.default.createElement(
        'section',
        {
          id: id,
          className: socialProofClasses,
          'data-building-block': 'organism'
        },
        this.renderHeadline(headline),
        this.renderCarousel(slides)
      );
    }
  }]);

  return SocialProof;
}(_react2.default.Component);

exports.default = SocialProof;


SocialProof.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-blue', 'theme-background-color-white', 'theme-background-color-light']).isRequired,
    fpti: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    carousel: _propTypes2.default.shape({
      goToSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      goToNextSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      goToPreviousSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      })
    }),
    slides: _propTypes2.default.arrayOf(_propTypes2.default.shape(_SocialProofItem2.default.propTypes)).isRequired
  }),
  className: _propTypes2.default.string
};

SocialProof.defaultProps = {
  config: {
    id: '',
    theme: 'theme-background-color-white',
    fpti: 'SocPrf-Carousel'
  },
  content: {
    carousel: {
      goToSlide: {
        text: 'Go to slide'
      },
      goToNextSlide: {
        text: 'Go to next slide'
      },
      goToPreviousSlide: {
        text: 'Go to previous slide'
      }
    },
    slides: [_SocialProofItem2.default.defaultProps, _SocialProofItem2.default.defaultProps]
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/social-proof/jsx/SocialProof.js
// module id = 1144
// module chunks = 4